<template>
  <modal :active="active" @close="handleCloseModal">
    <div v-if="actionType == 'createModal'" slot="title">Create New Asset</div>
    <div v-else slot="title">Update Asset</div>
    <div class="col-12" style="display: flex; justify-content: end">
      <div
        style="display: flex; align-items: center; justify-content: center"
        class="col-5"
      >
        <div v-if="!asset_image" class="image-upload">
          <media-browser
            filterBy="images"
            v-model="asset_image"
            :active="showMediaBrowserModal"
            @closeRequest="toggleMediaBrowserModal"
          ></media-browser>
          <i
            @click="toggleMediaBrowserModal"
            style="font-size: 170px"
            class="fa fa-image"
          ></i>
        </div>
        <div
          v-else
          style="display: flex; flex-direction: column; align-items: center"
        >
          <img
            :src="
              'data:image/' +
              asset_image.extension +
              ';base64,' +
              asset_image.image
            "
            alt=""
          />

          <div style="margin-top: 15px">
            <button
              style="
                border-radius: 30px;
                padding-top: 0px;
                padding-left: 7px;
                padding-right: 7px;
                padding-bottom: 0px;
              "
              @click="removeAssetImage()"
              type="button"
              class="btn btn-danger"
            >
              <i style="font-size: 12px" class="fa fa-trash"></i>
              Remove
            </button>
          </div>
        </div>
      </div>
      <div class="col-7">
        <div
          v-if="actionType == 'updateModal'"
          class="col-12"
          style="margin-top: 10px"
        >
          <label>Code: {{ code }}</label>
        </div>
        <div class="col-12">
          <label>Name</label>
          <input class="form-control" type="text" required v-model="name" />
        </div>
        <div class="col-12" style="margin-top: 10px">
          <label>Cluster</label>
          <select v-if="clusters" class="custom-select" v-model="cluster_id">
            <option
              v-for="cluster in clusters"
              :key="cluster.name"
              :value="cluster.id"
            >
              {{ cluster.name }}
            </option>
          </select>
        </div>
        <div class="col-12" style="margin-top: 10px">
          <label>Description</label>
          <textarea
            class="form-control"
            type="text"
            required
            v-model="description"
          />
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" class="btn btn-info" @click="handleSave()">
        Save
      </button>
    </div>
  </modal>
</template> 
 <script>
import Spinner from "vue-simple-spinner";
import Modal from "../../../../components/Modal.vue";
import AssetStorer from "../../../../storers/StoreAsset";
import AssetsFilter from "../../../../filters/AssetsFilter";
import MediaBrowser from "../../../common/MediaBrowser.vue";
import ClustersFilter from "../../../../filters/ClustersFilter";

import { mapState } from "vuex";
export default {
  data() {
    return {
      code: null,
      name: null,
      description: null,
      cluster_id: null,
      asset_image: null,
      showMediaBrowserModal: false,
    };
  },
  props: {
    active: Boolean,
    actionType: String,
    activeAsset: Object,
  },
  components: { Spinner, Modal, MediaBrowser },
  created: function () {
    var clustersFilter = ClustersFilter();
    this.$store.dispatch("searchClusters", {
      filter: clustersFilter,
      resultMode: "default",
    });
  },
  computed: {
    ...mapState({
      clusters: (state) => state.clusterStore.clusterSearch.clusters,
      assetsCount: (state) => state.assetStore.assetSearch.assetsCount,
    }),
  },
  methods: {
    init() {
      this.code = null;
      this.name = null;
      this.description = null;
      this.cluster_id = null;
      this.asset_image = null;
    },
    fillForm() {
      this.code = this.activeAsset.code;
      this.name = this.activeAsset.name;
      this.description = this.activeAsset.description;
      this.cluster_id = this.activeAsset.cluster_id;
      this.asset_image = this.activeAsset.asset_image;
    },
    removeAssetImage() {
      this.asset_image = null;
    },
    toggleMediaBrowserModal() {
      this.showMediaBrowserModal = !this.showMediaBrowserModal;
    },
    handleCloseModal() {
      this.$emit("closeRequest");
    },
    handleSave() {
      var asset = AssetStorer();
      if (this.actionType == "updateModal") {
        asset.id = this.activeAsset.id;
        asset.code = this.activeAsset.code;
      }
      asset.name = this.name;
      asset.description = this.description;
      asset.cluster_id = this.cluster_id;
      if (this.asset_image) {
        asset.media_id = this.asset_image.id;
      }
      this.$emit("saveRequest", asset);
    },
  },
  watch: {
    actionType() {
      this.init();
      if (this.actionType == "updateModal") {
        this.fillForm();
      }
    },
    active() {
      if (this.active && !this.code) {
        var assetsFilter = AssetsFilter();
        this.$store.dispatch("searchAssets", {
          filter: assetsFilter,
          resultMode: "count",
        });
      }
    },
  },
};
</script> 
 <style>
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/modals/assetModal.vue